/* tslint:disable */
/* eslint-disable */
/**
 * SONeu.WebApi | v1
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface JournalSupportResponse
 */
export interface JournalSupportResponse {
    /**
     * 
     * @type {string}
     * @memberof JournalSupportResponse
     */
    id: string;
    /**
     * 
     * @type {string}
     * @memberof JournalSupportResponse
     */
    userCode: string;
    /**
     * 
     * @type {string}
     * @memberof JournalSupportResponse
     */
    fullName: string;
    /**
     * 
     * @type {Date}
     * @memberof JournalSupportResponse
     */
    startTimeUtc: Date;
    /**
     * 
     * @type {Date}
     * @memberof JournalSupportResponse
     */
    endTimeUtc: Date;
    /**
     * 
     * @type {boolean}
     * @memberof JournalSupportResponse
     */
    isCurrentUser: boolean;
}

/**
 * Check if a given object implements the JournalSupportResponse interface.
 */
export function instanceOfJournalSupportResponse(value: object): value is JournalSupportResponse {
    if (!('id' in value) || value['id'] === undefined) return false;
    if (!('userCode' in value) || value['userCode'] === undefined) return false;
    if (!('fullName' in value) || value['fullName'] === undefined) return false;
    if (!('startTimeUtc' in value) || value['startTimeUtc'] === undefined) return false;
    if (!('endTimeUtc' in value) || value['endTimeUtc'] === undefined) return false;
    if (!('isCurrentUser' in value) || value['isCurrentUser'] === undefined) return false;
    return true;
}

export function JournalSupportResponseFromJSON(json: any): JournalSupportResponse {
    return JournalSupportResponseFromJSONTyped(json, false);
}

export function JournalSupportResponseFromJSONTyped(json: any, ignoreDiscriminator: boolean): JournalSupportResponse {
    if (json == null) {
        return json;
    }
    return {
        
        'id': json['id'],
        'userCode': json['userCode'],
        'fullName': json['fullName'],
        'startTimeUtc': (new Date(json['startTimeUtc'])),
        'endTimeUtc': (new Date(json['endTimeUtc'])),
        'isCurrentUser': json['isCurrentUser'],
    };
}

export function JournalSupportResponseToJSON(json: any): JournalSupportResponse {
    return JournalSupportResponseToJSONTyped(json, false);
}

export function JournalSupportResponseToJSONTyped(value?: JournalSupportResponse | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'id': value['id'],
        'userCode': value['userCode'],
        'fullName': value['fullName'],
        'startTimeUtc': value['startTimeUtc'].toISOString(),
        'endTimeUtc': value['endTimeUtc'].toISOString(),
        'isCurrentUser': value['isCurrentUser'],
    };
}

